export const productMixin = {
  methods: {
    isProductInStock: function (product) {
      return product.stock > 0 || product.preorder || product.backorder
    },
    isProductPlentyInStock: function (product) {
      return product.stock > 1 || product.preorder || product.backorder
    },
    getAllProductsFromPickupPoint: function (pickupPoint) {
      let self = this
      let products = []
      if (pickupPoint.users && pickupPoint.users.length > 0) {
        pickupPoint.users.forEach(function (user) {
          let restProducts = self.getAllProductsFromUser(user)
          if (restProducts && restProducts.length > 0) {
            restProducts.forEach(function (product) {
              self.processProduct(products, product)
            })
          }
        })
      }
      return this.sortProducts(products)
    },
    getAllProductsFromUsers: function (users) {
      let self = this
      let products = []
      if (users && users.length > 0) {
        users.forEach(function (user) {
          let restProducts = self.getAllProductsFromUser(user)
          if (restProducts && restProducts.length > 0) {
            restProducts.forEach(function (product) {
              self.processProduct(products, product)
            })
          }
        })
      }
      return this.sortProducts(products)
    },
    getAllProductsFromUser: function (user) {
      let self = this
      let products = []
      if (user.products && user.products.length > 0) {
        user.products.forEach(function (product) {
          self.processProduct(products, product)
        })
      }
      if (user.pickups) {
        let pickupPoints = user.pickups.filter(function (pickup) {
          return pickup.city && pickup.country
        })
        if (pickupPoints && pickupPoints.length > 0) {
          pickupPoints.forEach(function (pickupPoint) {
            let restProducts = self.getAllProductsFromPickupPoint(pickupPoint)
            if (restProducts && restProducts.length > 0) {
              restProducts.forEach(function (product) {
                self.processProduct(products, product)
              })
            }
          })
        }
        let pickupBys = user.pickups.filter(function (pickup) {
          return !(pickup.city && pickup.country)
        })
        if (pickupBys && pickupBys.length > 0) {
          pickupBys.forEach(function (pickupBy) {
            let restProducts = self.getAllProductsFromUser(pickupBy)
            if (restProducts && restProducts.length > 0) {
              restProducts.forEach(function (product) {
                self.processProduct(products, product)
              })
            }
          })
        }
      }
      return this.sortProducts(products)
    },
    processProduct: function (products, product) {
      let existingProductsList = products.filter(function (existingProduct) {
        return existingProduct.id === product.id && existingProduct.type === product.type
      })
      if (existingProductsList.length > 0) {
        existingProductsList[0].amount += product.amount
      } else {
        products.push(JSON.parse(JSON.stringify(product)))
      }
    },
    sortProducts: function (products) {
      return products.sort(function (a, b) {
        let type1 = a.type
        let type2 = b.type
        if (type1 !== type2) {
          if (type1 === 'addon') {
            return 1
          } else {
            return -1
          }
        } else {
          return a.id - b.id
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/product.js